<template>
  <div>
    <br />
    <hr />
    <b-row class="ml-1 mr-1 mb-1">
      <b-col>
        <h6>
          <i class="far fa-money-bill-alt mr-2" />Vendas e Recebimentos:
        </h6>
        <div class="text-muted">
          Dinheiro: {{ getOrderSumByPaymentMethod(1) | moneyBr }}
        </div>
        <div class="text-muted">
          Cheque: {{ getOrderSumByPaymentMethod(2) | moneyBr }}
        </div>
        <div class="text-muted">
          Cartão crédito: {{ getOrderSumByPaymentMethod(3) | moneyBr }}
        </div>
        <div class="text-muted">
          Cartão débito: {{ getOrderSumByPaymentMethod(4) | moneyBr }}
        </div>
        <div class="text-muted">
          Crediário: {{ getOrderSumByPaymentMethod(5) | moneyBr }}
        </div>
        <div class="text-muted">
          Boleto Bancário: {{ getOrderSumByPaymentMethod(15) | moneyBr }}
        </div>
        <div class="text-muted">
          Depósito Bancário: {{ getOrderSumByPaymentMethod(16) | moneyBr }}
        </div>
        <div class="text-muted">
          PIX: {{ getOrderSumByPaymentMethod(17) | moneyBr }}
        </div>
        <div class="text-muted">
          Carteira Digital: {{ getOrderSumByPaymentMethod(18) | moneyBr }}
        </div>
        <div class="text-muted">
          Outros: {{ getOrderSumByPaymentMethod(99) | moneyBr }}
        </div>
        <div class="text-muted">
          <b>Total em Vendas: {{ orderSum - billReceivebleSum | decimal }}</b>
        </div>
        <div class="text-muted">
          <b>Total em Recebimentos: {{ billReceivebleSum | decimal }}</b>
        </div>
      </b-col>
      <hr />
      <b-col>
        <h6 class="ml-2 mr-2">
          <i class="fas fa-dollar-sign mr-2" />Saldo inicial:
          {{ openingBalance | moneyBr }}
        </h6>
        <h6 class="ml-2 mr-2">
          <i class="fas fa-exchange-alt mr-2" />Transferências:
          {{ totalTransfer | moneyBr }}
        </h6>
        <h6 class="ml-2 mr-2">
          <i class="fas fa-not-equal mr-2" style="color: red" />Diferença:
          {{ totalDiference | moneyBr }}
        </h6>
        <h6 class="ml-2 mr-2">
          <i class="fas fa-equals mr-2" />Resultado:
          {{ (totalIn + totalOut) | moneyBr }}
        </h6>
        <h6 class="ml-2 mr-2">
          <i class="fas fa-dollar-sign mr-2" />Saldo final:
          {{ closingBalance | moneyBr }}
        </h6>
      </b-col>
    </b-row>
    <hr />
    <b-row class="ml-1 mr-1 mb-1">
      <b-col>
        <h6>
          <i class="fas fa-arrow-down mr-2" style="color: red" />Saídas:
          {{ totalOut | moneyBr }}
        </h6>
        <div class="text-muted">
          Devoluções em Dinheiro:{{ getSumByOriginAndType("o", "o") | moneyBr }}
        </div>
        <div class="text-muted">
          Créditos de clientes:
          {{ getSumByOriginAndType("br", "o") | moneyBr }}
        </div>
        <div class="text-muted">
          Pagamentos de contas:
          {{ getSumByOriginAndType("bp", "o") | moneyBr }}
        </div>
        <div class="text-muted">
          Outras saídas
          {{ getSumByOriginAndType("c", "o") | moneyBr }}
        </div>
      </b-col>
      <b-col>
        <h6>
          <i class="fas fa-arrow-up mr-2" style="color: green" />Entradas:
          {{ totalIn | moneyBr }}
        </h6>
        <div class="text-muted">
          Vendas em dinheiro:
          {{ getSumByOriginAndType("o", "i") | moneyBr }}
        </div>
        <div class="text-muted">
          Recebimento de Clientes:
          {{ getSumByOriginAndType("br", "i") | moneyBr }}
        </div>
        <div class="text-muted">
          Outras entradas: {{ getSumByOriginAndType("c", "i") | moneyBr }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    accountResume: {
      default: () => ({
        sumByOrigin: [],
        sumOrderByPaymentMethod: [],
        closingBalance: {
          closingBalance: 0,
        },
        openingBalance: {
          openingBalance: 0,
        },
      }),
    },
  },

  computed: {
    openingBalance() {
      return this.$store.getters["drawer/openingBalance"];
    },

    closingBalance() {
      return this.$store.getters["drawer/closingBalance"];
    },

    totalIn() {
      return this.$store.getters["drawer/totalIn"];
    },

    totalOut() {
      return this.$store.getters["drawer/totalOut"];
    },

    orderSum() {
      return this.$store.getters["drawer/orderSum"];
    },
    billReceivebleSum() {
      return this.$store.getters["drawer/billReceivebleSum"];
    },

    totalDiference() {
      return this.$store.getters["drawer/totalDiference"];
    },

    totalTransfer() {
      return this.$store.getters["drawer/totalTransfer"];
    },
  },

  methods: {
    getSumByOriginAndType(origin, type) {
      return this.$store.getters["drawer/getSumByOriginAndType"](origin, type);
    },

    getOrderSumByPaymentMethod(paymentMethod) {
      return this.$store.getters["drawer/getOrderSumByPaymentMethod"](
        paymentMethod
      );
    },
  },
};
</script>

<style></style>
